import Joi from "joi";

const JoiOption = Joi.object({
  label: Joi.string(),
  value: Joi.string(),
  checked: Joi.any(),
});

const schema = Joi.object({
  bank_account: Joi.object({
    label: Joi.string(),
    value: Joi.string(),
    checked: Joi.any(),
  }),
  bank_account_name: Joi.string().required().messages({ "string.empty": "Harap mengisi Nama pemilik rekening" }),
  bank_account_number: Joi.string().required().messages({ "string.empty": "Harap mengisi No. rekening vendor" }),
  pool_department: Joi.array().items(
    Joi.object({
      codeType: JoiOption.required().messages({ "any.required": "Harap mengisi Tipe user" }),
      area: JoiOption.required().messages({ "any.required": "Harap mengisi Wilayah" }),
      pool: JoiOption.required().messages({ "any.required": "Harap mengisi Pool" }),
      department: Joi.string().required().messages({ "string.empty": "Harap mengisi Departemen" }),
    }),
  ),
  status_vendor: Joi.string().required().messages({ "string.empty": "Harap mengisi Status vendor" }),
  type_vendor: Joi.string().required().messages({ "string.empty": "Harap mengisi Tipe vendor" }),
  vendor_address: Joi.string().required().messages({ "string.empty": "Harap mengisi Alamat vendor" }),
  vendor_files: Joi.array().items(
    Joi.object({
      item_id: Joi.number(),
      file_name: Joi.string(),
      file_base64: Joi.string(),
      file_size: Joi.string(),
      create_by: Joi.string(),
    }),
  ),
  vendor_name: Joi.string().required().messages({ "string.empty": "Harap mengisi Nama vendor" }),
});

export default schema;
